/* DON'T EDIT THIS FILE: edit original and run build again */ const onboardingTermsOfUseTitle =
  "Términos y Condiciones generales sobre la operatoria";

export default onboardingTermsOfUseTitle;
